import React, { useState } from "react";
import * as APIModels from "../../../../models";
import { Modal, Button } from "react-bootstrap";

export type AttorneyModalProps = {
    attorney?: APIModels.Party | undefined;
    show: boolean;
    onClose: () => void;
    onSave: (leadAttorney: APIModels.Party, isNew?: boolean) => void;
};

const LeadAttorneyModal = (params: AttorneyModalProps) => {
    const [leadAttorney, setLeadAttorney] = useState<APIModels.Party>(
        params.attorney ?? { ...new APIModels.Party(), isLeadAttorney: true }
    );
    const [newLeadAttorney, setNewLeadAttorney] = useState<boolean>(false);
    const [errors, setErrors] = useState<{
        firstName?: string;
        lastName?: string;
        barNumber?: string;
    }>({});

    const validate = (): boolean => {
        const newErrors: {
            firstName?: string;
            lastName?: string;
            barNumber?: string;
        } = {};
        if (!leadAttorney.firstName?.trim())
            newErrors.firstName = "First name is required.";
        if (!leadAttorney.lastName?.trim())
            newErrors.lastName = "Last name is required.";
        if (!leadAttorney.barNumber?.trim())
            newErrors.barNumber = "Bar number is required.";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const onSaveButton: React.MouseEventHandler<HTMLButtonElement> = () => {
        if (!validate()) return;
        return params.onSave(leadAttorney, newLeadAttorney);
    };

    const onFirstNameChange: React.ChangeEventHandler<HTMLInputElement> = (
        e
    ) => {
        const firstNameValue: string = e.currentTarget.value;
        setLeadAttorney({
            ...leadAttorney,
            firstName: firstNameValue,
        });
    };

    const onMiddleNameChange: React.ChangeEventHandler<HTMLInputElement> = (
        e
    ) => {
        const middleNameValue: string = e.currentTarget.value;
        setLeadAttorney({
            ...leadAttorney,
            middleName: middleNameValue,
        });
    };

    const onLastNameChange: React.ChangeEventHandler<HTMLInputElement> = (
        e
    ) => {
        const lastNameValue: string = e.currentTarget.value;
        setLeadAttorney({
            ...leadAttorney,
            lastName: lastNameValue,
        });
    };

    const onBarNumberChange: React.ChangeEventHandler<HTMLInputElement> = (
        e
    ) => {
        const barNumberValue: string = e.currentTarget.value;
        setLeadAttorney({
            ...leadAttorney,
            barNumber: barNumberValue,
        });
    };

    return (
        <Modal
            show={params.show}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    Lead Attorney
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="mt-4">
                    <div className="mt-1">
                        <input
                            name="holdReasonInput"
                            className={`form-control${
                                errors.firstName ? " is-invalid" : ""
                            }`}
                            type="text"
                            id="attorneyModalFirstName"
                            value={leadAttorney.firstName}
                            onChange={onFirstNameChange}
                        />
                        <label
                            className="form-check-label strikethrough"
                            htmlFor="attorneyModalFirstName"
                        >
                            Attorney First Name
                        </label>
                        {errors.firstName && (
                            <div className="invalid-feedback">
                                {errors.firstName}
                            </div>
                        )}
                    </div>
                </div>
                <div className="mt-4">
                    <div className="mt-1">
                        <input
                            name="holdReasonInput"
                            className="form-control"
                            type="text"
                            id="attorneyModalMiddleName"
                            value={leadAttorney.middleName}
                            onChange={onMiddleNameChange}
                        />
                        <label
                            className="form-check-label strikethrough"
                            htmlFor="attorneyModalMiddleName"
                        >
                            Attorney Middle Name
                        </label>
                    </div>
                </div>
                <div className="mt-4">
                    <div className="mt-1">
                        <input
                            name="attorneyModalLastName"
                            className={`form-control${
                                errors.lastName ? " is-invalid" : ""
                            }`}
                            type="text"
                            id="attorneyModalLastName"
                            value={leadAttorney.lastName}
                            onChange={onLastNameChange}
                        />
                        <label
                            className="form-check-label strikethrough"
                            htmlFor="attorneyModalLastName"
                        >
                            Attorney Last Name
                        </label>
                        {errors.lastName && (
                            <div className="invalid-feedback">
                                {errors.lastName}
                            </div>
                        )}
                    </div>
                </div>
                <div className="mt-4">
                    <div className="mt-1">
                        <input
                            name="attorneyModalBarNumber"
                            className={`form-control${
                                errors.barNumber ? " is-invalid" : ""
                            }`}
                            type="text"
                            id="attorneyModalBarNumber"
                            value={leadAttorney.barNumber}
                            onChange={onBarNumberChange}
                        />
                        <label
                            className="form-label strikethrough"
                            htmlFor="attorneyModalBarNumber"
                        >
                            Attorney Bar Number
                        </label>
                        {errors.barNumber && (
                            <div className="invalid-feedback">
                                {errors.barNumber}
                            </div>
                        )}
                    </div>
                </div>
                <div className="form-check mt-1">
                    <input
                        name="isNewAttorneyCheckBox"
                        className="form-check-input"
                        type="checkbox"
                        id="isNewAttorneyCheckBox"
                        value=""
                        onChange={(e) =>
                            setNewLeadAttorney(e.currentTarget.checked)
                        }
                    />
                    <label
                        className="form-check-label strikethrough"
                        htmlFor="radioInvalidCaseNum"
                    >
                        Is This Person a new Attorney
                    </label>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={onSaveButton}>Save</Button>
                <Button onClick={params.onClose}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default LeadAttorneyModal;
